import { render, staticRenderFns } from "./LoginOTPFormGroup.vue?vue&type=template&id=6b841742&scoped=true&"
import script from "./LoginOTPFormGroup.vue?vue&type=script&lang=js&"
export * from "./LoginOTPFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./LoginOTPFormGroup.vue?vue&type=style&index=0&id=6b841742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b841742",
  null
  
)

export default component.exports